import {  memo  } from 'react';
import List from '@mui/material/List';
import MapListItemBarrierFree from './MapListItemBarrierFree.js';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import ListItem from '@mui/material/ListItem';
import { useTranslation } from "react-i18next";


const MapListBarrierFree = memo((props) => {
    const {dataList , selectData} = props;
  //--- 多言語対応 ---
  const { t } = useTranslation();

    const data = () =>{
        return [
            {
              title: t("category.elevator"),
              data: dataList.filter(
                el => el.category === 'elevator' && el.name !== '',
              ),
              img: 'elevator.svg',
            },
            {
                title: t("category.toilet"),
                data: dataList.filter(
                  el => el.category === 'toilet' && el.name !== '',
                ),
                img: 'toilet.svg',
            },
            {
                title: t("category.slope"),
                data: dataList.filter(
                  el => el.category === 'slope' && el.name !== '',
                ),
                img: 'slope.svg',
            }
        ];
    }

    return (
        <div className="leaflet-container">
            <List className="map-list">
            {
                data().map((row, sIndex) => {
                    return <Box key={sIndex}>
                        {
                        row.data.length > 0?
                        <ListItem alignItems="flex-start">
                            <Card className={"barrierListItem section"}>
                            <Box sx={{display:'flex'}}>
                                {
                                row.img !== 'no-image@3x.png'?
                                <>
                                <CardMedia
                                    component="img"
                                    sx={{width:"35px"}}
                                    image={"/assets/images/mapIcons/" + row.img}/>
                                <Box>{row.title}</Box>
                                </>
                                :<Box sx={{textAlign:'center',width:'100%',marginRight:'10px'}}>{row.title}</Box>
                                }
                            </Box>
                            </Card>
                        </ListItem>:<></>
                        }
                        <MapListItemBarrierFree dataList={row.data} selectData={selectData} />
                    </Box>
                })
            }
            </List>
        </div>
    )
});
export default MapListBarrierFree